<!-- Desktop-Ansicht -->
<div class="main-container-position" data-testid="offer-details-root">
  <div class="container-width">
    <div class="desktop-layout">
      <div class="flex flex-row align-middle">
        <button
          class="flex items-center text-white font-bold"
          (click)="goBack()"
        >
          <span
            class="material-icons mr-1 text-black text-xl rounded-full outline-1"
            i18n
            >arrow_back</span
          >
        </button>
        <p
          (click)="goBack()"
          class="text-sm mb-0 py-8 hover:cursor-pointer"
          tabindex="0"
          role="button"
          (keyup.enter)="goBack()"
        >
          Zurück
        </p>
      </div>
      <div class="grid grid-cols-2 gap-8">
        <div class="space-y-6">
          <div
            class="w-full h-64 flex items-center justify-center max-w-[300px]"
          >
            @if (loadingStates.offer) {
              <app-loading-indication
                displayText="Lade Medien..."
                size="medium"
              ></app-loading-indication>
            } @else {
              <app-offer-media-display
                style="height: inherit"
                [offer]="offer"
                [showDownloadPdf]="true"
              ></app-offer-media-display>
            }
          </div>

          <div>
            <div
              class="px-3 py-1 rounded-full text-sm bg-gray-700 text-white w-fit flex justify-center mb-4 h-fit"
            >
              <mat-icon class="text-white text-sm">{{
                offer.offerType.icon
              }}</mat-icon>
              <span>
                {{ offer.offerType.offerName }}
              </span>
            </div>
            @if (loadingStates.company) {
              <app-skeleton-loading
                [showLoadingText]="true"
                [loadingText]="'Angebot von ...'"
                [showTabs]="false"
                [numberOfCards]="0"
                [numberOfTabs]="0"
                [containerClass]="'bg-gray-100 p-6 rounded-lg h-[250px]'"
              ></app-skeleton-loading>
            } @else {
              <div
                class="text-md text-black leading-tight !mt-2 mb-4"
                data-testid="offer-company-block"
              >
                <p>
                  Angebot von:
                  <span class="font-bold" data-testid="offer-company-name">{{
                    company.companyName
                  }}</span>
                </p>
              </div>
              <p class="flex flex-row">
                <span class="p-2 material-symbols-outlined"> location_on </span>
                <span class="py-2" data-testid="offer-company-address"
                  >{{ company.address?.streetAndNumber }},
                  {{ company.address?.postalCode }}
                  {{ company.address?.city }}</span
                >
              </p>
              @if (company.website) {
                <p class="flex flex-row">
                  <span class="p-2 material-symbols-outlined"> language </span>
                  <a
                    [href]="
                      company.website.startsWith('http')
                        ? company.website
                        : 'https://' + company.website
                    "
                    target="_blank"
                    class="py-2 text-blue-600 hover:underline"
                    data-testid="offer-company-website"
                    >{{ company.website }}</a
                  >
                </p>
              }
            }
          </div>
          <div></div>
        </div>
        <div>
          <div class="">
            @if (loadingStates.offer) {
              <app-loading-indication
                displayText="Lade Angebot..."
                size="medium"
              ></app-loading-indication>
            } @else {
              <h1
                class="text-3xl font-bold !mt-0 !mb-2"
                data-testid="offer-title"
              >
                {{ offer.name }}
              </h1>

              @if (offer.appointmentDateTime && offer.offerType.requiresDate) {
                <div
                  class="px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800 w-fit flex justify-center mb-4 h-fit"
                >
                  <mat-icon class="text-blue-800 text-sm">event</mat-icon>
                  <span class="ml-1">
                    {{ offer.appointmentDateTime | date: "dd.MM.yyyy HH:mm" }}
                    Uhr
                  </span>
                </div>
              }

              <div class="mb-4 gap-2">
                <div class="flex flex-row items-center mb-1">
                  <mat-icon class="">category</mat-icon>

                  <h3 class="ml-2 font-bold text-md mb-0">Kategorien</h3>
                </div>
                <div
                  class="flex flex-wrap gap-2 ml-6"
                  data-testid="offer-categories"
                >
                  @for (category of categories; track category) {
                    <div
                      class="px-3 py-1 rounded-full text-sm bg-green-100 flex flex-wrap w-fit"
                    >
                      {{ category }}
                    </div>
                  }
                </div>
              </div>

              <!-- Add offer location display component -->
              <app-offer-location-display
                [offer]="offer"
                class="mb-4 block"
                data-testid="offer-location-block"
              ></app-offer-location-display>

              <p
                class="text-black"
                [innerHTML]="offer.description"
                data-testid="offer-description"
              ></p>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile-Ansicht -->
    <div class="mobile-layout">
      <div class="flex flex-col space-y-6">
        <div class="flex flex-row align-middle">
          <button
            class="flex items-center hover:bg-gray-300 text-white font-bold rounded-full"
            (click)="goBack()"
          >
            <span
              class="material-icons mr-1 text-black text-xl rounded-full outline-1"
              i18n
              >arrow_back</span
            >
          </button>
          <p
            (click)="goBack()"
            class="text-sm mb-0 py-8 hover:cursor-pointer"
            tabindex="0"
            role="button"
            (keyup.enter)="goBack()"
          >
            Zurück
          </p>
        </div>

        <div
          class="w-full flex items-center justify-center max-w-[300px] self-center"
        >
          @if (loadingStates.offer) {
            <app-loading-indication
              displayText="Lade Medien..."
              size="medium"
            ></app-loading-indication>
          } @else {
            <app-offer-media-display
              style="height: inherit"
              [offer]="offer"
            ></app-offer-media-display>
          }
        </div>
        @if (loadingStates.offer) {
          <app-loading-indication
            displayText="Lade Angebot..."
            size="medium"
          ></app-loading-indication>
        } @else {
          <span class="text-3xl font-bold mb-0 leading-tight">{{
            offer.name
          }}</span>

          <div
            class="px-3 py-1 rounded-full text-sm bg-gray-700 text-white w-fit flex justify-center h-fit"
          >
            <mat-icon class="text-white text-sm">{{
              offer.offerType.icon
            }}</mat-icon>
            <span>
              {{ offer.offerType.offerName }}
            </span>
          </div>

          @if (offer.appointmentDateTime && offer.offerType.requiresDate) {
            <div
              class="px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800 w-fit flex justify-center h-fit"
            >
              <mat-icon class="text-blue-800 text-sm">event</mat-icon>
              <span class="ml-1">
                {{ offer.appointmentDateTime | date: "dd.MM.yyyy HH:mm" }} Uhr
              </span>
            </div>
          }
        }

        <!-- Add offer location display component for mobile -->
        @if (!loadingStates.offer) {
          <app-offer-location-display
            [offer]="offer"
          ></app-offer-location-display>
          <div class="mb-4 gap-2">
            <div class="flex flex-row items-center mb-1">
              <mat-icon class="">category</mat-icon>

              <h3 class="ml-2 font-bold text-md mb-0">Kategorien</h3>
            </div>
            <div class="flex flex-wrap gap-2 ml-6">
              @for (category of categories; track category) {
                <div
                  class="px-3 py-1 rounded-full text-sm bg-green-100 flex flex-wrap w-fit"
                >
                  {{ category }}
                </div>
              }
            </div>
          </div>
        }
        @if (loadingStates.company) {
          <app-loading-indication
            displayText="Lade Firmendaten..."
            size="medium"
          ></app-loading-indication>
        } @else {
          <div class="text-md text-black leading-tight !mt-4">
            <p>
              Angebot von:
              <span class="font-bold">{{ company.companyName }}</span>
            </p>

            <p class="flex flex-row">
              <span class="p-2 material-symbols-outlined"> location_on </span>
              <span class="py-2"
                >{{ company.address?.streetAndNumber }},
                {{ company.address?.postalCode }}
                {{ company.address?.city }}</span
              >
            </p>
            @if (company.website) {
              <p class="flex flex-row">
                <span class="p-2 material-symbols-outlined"> language </span>
                <a
                  [href]="
                    company.website.startsWith('http')
                      ? company.website
                      : 'https://' + company.website
                  "
                  target="_blank"
                  class="py-2 text-blue-600 hover:underline"
                  >{{ company.website }}</a
                >
              </p>
            }
          </div>
        }
        @if (loadingStates.offer) {
          <app-loading-indication
            displayText="Lade Angebot..."
            size="medium"
          ></app-loading-indication>
        } @else {
          <div>
            <p class="text-black" [innerHTML]="offer.description"></p>
          </div>
        }
      </div>
    </div>
  </div>
</div>
